import { useLocation } from 'react-router-dom';

import { ROUTE_PATH } from '@shared/constants/route-path.enum';
import { USER_TYPE } from '@shared/models/UserType.model';

import { selectAuth } from '@shared/store/auth/auth.selectors';
import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import DashboardUnauthorized from '../pages/DashboardUnauthorizedPage.component.tsx';

type AllowedAccess = {
  [key in USER_TYPE]: ROUTE_PATH[];
};

const AllowedPathPerUserType: AllowedAccess = {
  [USER_TYPE.EXTERNAL_INSURED]: [
    ROUTE_PATH.CORRESPONDENCES,
    ROUTE_PATH.NOTIFICATIONS,
    ROUTE_PATH.SERVICES,
    ROUTE_PATH.CONTRIBUTIONS,
    ROUTE_PATH.INSURED_HISTORY,
    ROUTE_PATH.DISABILITY,
    ROUTE_PATH.CERTIFICATES,
    ROUTE_PATH.INSURANCE_CLEARANCE_CERTIFICATION,
    ROUTE_PATH.IRIS_PAYMENT_HISTORY,
    ROUTE_PATH.SETTINGS
  ]
};

const ProtectedRoute = (props: { element: ReactElement }) => {
  const userType = useSelector(selectAuth).userType;

  const location = useLocation();
  const pathname = location.pathname.split('/')[1] as ROUTE_PATH;
  const indexRoute = location.pathname === '/';
  const { element } = props;
  const hasAccessToRoute = (!!userType && AllowedPathPerUserType[userType]?.includes(pathname)) || indexRoute;

  return !hasAccessToRoute ? <DashboardUnauthorized /> : element;
};

export default ProtectedRoute;
